/* import __COLOCATED_TEMPLATE__ from './monitor-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class MonitorCardComponent extends Component 
{
	@tracked errLog = [];
	@tracked stdLog = [];
	
	@service socketGuru;
		
	constructor()
	{
		super(...arguments);
		this._boundHandleSocketEvent = this._handleSocketEvent.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundHandleSocketEvent);
    }

    willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundHandleSocketEvent);
		super.willDestroy();
    }
	
    _handleSocketEvent(event)
	{
		const { eventName, data: eventData } = event.detail;
		if(eventName == "stdErr")
		{
			let data = JSON.parse(eventData);

			var message = String.fromCharCode.apply(null, data.message.data)
			var chipDisplay = data.chip ? " Chip: "+data.chip : "";
			var nameDisplay = data.chipName ? " Name: "+data.chipName : "";
			this.errLog = [...this.errLog, "Device: "+data.device+" Bib: "+data.bib+chipDisplay+nameDisplay+" Time: "+data.time+" "+message];
		}
		if(eventName == "stdOut")
		{
			let data = JSON.parse(eventData);

			var message = String.fromCharCode.apply(null, data.message.data)
			var chipDisplay = data.chip ? " Chip: "+data.chip : "";
			var nameDisplay = data.chipName ? " Name: "+data.chipName : "";
			this.stdLog = [...this.stdLog, "Device: "+data.device+" Bib: "+data.bib+chipDisplay+nameDisplay+" Time: "+data.time+" "+message];
		}
    }
}



